import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    PagingInfo
} from "src/app/shared/vo";
import {
    FvmsCommonService
    ,FvmsApiDtgReportCarService
    ,FvmsApiDtgDriveSafeEcoService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    selector: "report-car-day-summary"
    ,templateUrl: './dtg.report.car.day.summary.component.html'
    ,providers: []
})
export class DtgReportCarDaySummaryComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    DtgListType = DtgListType;
    selectedDate:any;
    listSummary:any[];

    @Input()
    set inputSelectedDate(selectedDate){
        this.selectedDate = selectedDate;
        if(selectedDate){
            this.reloadListSummary();
        }
    }

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private fvmsApiDtgDriveSafeEcoService:FvmsApiDtgDriveSafeEcoService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListSummary(){
        if(this.selectedDate){
            let searchDateFrom = this.selectedDate.searchDateFrom;
            let searchDateTo = this.selectedDate.searchDateTo;
            let searchInfo = {
                companyId:this.companyInfo?.companyId || 0
                ,dtgEid:this.companyInfo?.dtgEid || ""
                ,searchDateFrom:searchDateFrom
                ,searchDateTo:searchDateTo
                ,dtgGroupByRegDtYy:"Y"
                ,dtgGroupByRegDtMm:"Y"
                ,dtgGroupByRegDtDd:"Y"
            };
            let pagingInfoSum = new PagingInfo();
            pagingInfoSum.pageSize = 999;
            this.fvmsApiDtgDriveSafeEcoService.getListReportSafeDriving(searchInfo,pagingInfoSum)
            // this.fvmsApiDtgReportCarService.getListReportCarSumAll(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    this.listSummary = []
                    if(apiResponse.resultStatus === "ok"){
                        if(apiResponse.resultValue){
                            // console.log("reloadListSummary",apiResponse.resultValue);
                            if(apiResponse.resultValue && apiResponse.resultValue.length > 0){
                                this.listSummary = apiResponse.resultValue;
                            }
                        }
                    }
                });
        }
    }

    //전체 운행대수
    getSumDriveCnt(){
        // return this.listSummary?.dtgDriveCarCnt || 0;
        return 0;
    }

    //일평균 운행대수
    getAvgDriveCnt(){
        return 0;
        // let sumCnt = this.getSumDriveCnt();
        // let listCnt = this.listSummary?.diffDay || 1;
        // return Math.round(sumCnt / listCnt);
    }

    //전체 운행거리
    getSumDist(){
        if(!this.listSummary) return 0;
        let sumData = this.listSummary.reduce((sum,item) => {
            return sum + item.dtgDistAccumul;
        },0);
        return sumData;
    }

    //일평균 운행거리
    getAvgDist(){
        if(!this.listSummary) return 0;
        let sumCnt = this.getSumDist() || 0;
        let listCnt = this.listSummary.length || 1;
        return Math.round(sumCnt / listCnt);
    }

    //전체 운행시간
    getSumDuration(){
        if(!this.listSummary) return 0;
        let sumData = this.listSummary.reduce((sum,item) => {
            return sum + item.dtgRegDtDuration;
        },0);
        return sumData;
    }

    //일평균 운행시간
    getAvgDuration(){
        if(!this.listSummary) return 0;
        let sumCnt = this.getSumDuration() || 0;
        let listCnt = this.listSummary.length || 1;
        return Math.round(sumCnt / listCnt);
    }

    //전체 연료소모량
    getSumOilUse(){
        if(!this.listSummary) return 0;
        let sumData = this.listSummary.reduce((sum,item) => {
            return sum + item.dtgOilUseAccumul;
        },0);
        return sumData;
    }

    //일평균 연료소모량
    getAvgOilUse(){
        if(!this.listSummary) return 0;
        let sumCnt = this.getSumOilUse() || 0;
        let listCnt = this.listSummary.length || 1;
        return Math.round(sumCnt / listCnt);
    }
}